// TODO: consider moving these to environment Github secrets and Github Actions (esp: `apiKey`)
const projectId = 'daring-calling-280401'
export default {
  apiKey: "AIzaSyCqG8vD1l754bK2R7PmXrgYyKl2mCe8ZlQ",
  authDomain: `${projectId}.firebaseapp.com`,
  databaseURL: `https://${projectId}.firebaseio.com`,
  projectId: projectId,
  storageBucket: `${projectId}.appspot.com`,
  messagingSenderId: "771050794368",
  appId: "1:771050794368:web:086c154476f4f129b46565",
  measurementId: "G-9RPSYL8SY8",
};
